export default "__VITE_ASSET__BJCqPNLP__"